const agencyLabels = [
    {
        title: 'Agency Body',
        type: 'columns',
        fields: [
            {
                label: '[COMPANYNAME]',
                description: 'company_name',
                visible: true
            },
            {
                label: '[NAMEAGENCY]',
                description: 'name_agency',
                visible: true
            },
            {
                label: '[ADDRESSAGENCY]',
                description: 'address_agency',
                visible: true
            },
            {
                label: '[EMAILAGENCY]',
                description: 'email_agency',
                visible: true
            },
            {
                label: '[PHONELAGENCY]',
                description: 'phone_agency',
                visible: true
            }
        ]
    }
];

export default agencyLabels;
